module.exports = __webpack_public_path__ + "img/bmc.f2eabe77.svg";